/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiSimpleComponentFromJSON, ApiSimpleComponentToJSON, } from './ApiSimpleComponent';
export function ApiListComponentsResponseFromJSON(json) {
    return ApiListComponentsResponseFromJSONTyped(json, false);
}
export function ApiListComponentsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'components': !exists(json, 'components') ? undefined : (json['components'].map(ApiSimpleComponentFromJSON)),
    };
}
export function ApiListComponentsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'components': value.components === undefined ? undefined : (value.components.map(ApiSimpleComponentToJSON)),
    };
}
